import { useContext } from 'react';
import ComparatorContext, { getStorage } from '../comparator-context';

export const useStorage = () => {
  const { getStateFromLocalStorage, persistStateInLocalStorage } =
    useContext(ComparatorContext);
  return getStorage({ getStateFromLocalStorage, persistStateInLocalStorage });
};
